export const VIEWS = {
  CALENDAR: 'calendar',
  LIST: 'list',
};

// Пустой менеджер для селектора Ответственный в задачах
export const EMPTY_MANAGER = {
  avatarUrl: null,
  email: '',
  id: 'none',
  name: 'Без исполнителя',
  phone: null,
  title: 'Без исполнителя>',
  value: 'none',
};
